class Environment {
    static FLASK_HOST_URL;
    static API_URL;
    static MANUAL_VERIFICATION_HOST_URL;
    static GOOGLE_API_KEY;
    static USE_TEST_MODE;
    static CLIENT_BACKEND_URL;
    static BRAND_FETCH_CLIENT_ID;
    static BRAND_DASHBOARD_URL;

    static initialize() {
        const useTestModeString = process.env.REACT_APP_USE_TEST_MODE || "false";
        this.USE_TEST_MODE = useTestModeString.toLowerCase() === "true";
        if (process.env.NODE_ENV === "production") {
            this.FLASK_HOST_URL = this.USE_TEST_MODE
                ? "https://foodfluenceapp-dev.uc.r.appspot.com"
                : "https://foodfluenceapp-554a6.uc.r.appspot.com";
            this.API_URL = this.USE_TEST_MODE
                ? "https://influencers-dot-foodfluenceapp-dev.uc.r.appspot.com/api"
                : "https://influencers-dot-foodfluenceapp-554a6.uc.r.appspot.com/api";
            this.CLIENT_BACKEND_URL = this.USE_TEST_MODE
                ? "https://foodfluence-client-backend-dev-819708887106.us-central1.run.app/api"
                : "https://foodfluence-client-backend-prod-222795274748.us-central1.run.app/api";
        } else {
            this.FLASK_HOST_URL = "http://localhost:5000";
            const apiOverride = process.env.REACT_APP_API_URL?.trim();
            if (apiOverride) {
                this.API_URL = apiOverride;
            } else if (
                typeof window !== "undefined" &&
                window.location.hostname !== "localhost" &&
                window.location.hostname !== "127.0.0.1"
            ) {
                // ngrok / LAN dev host — same origin, proxied to :8080 via setupProxy.js
                this.API_URL = `${window.location.origin}/api`;
            } else {
                this.API_URL = "http://localhost:8080/api";
            }
            this.CLIENT_BACKEND_URL = "http://127.0.0.1:8081/api";
        }

        if (this.USE_TEST_MODE) {
            console.warn("Using test mode!");
            this.GOOGLE_API_KEY = process.env.REACT_APP_GOOGLE_API_KEY_TEST ?? "";
            this.MANUAL_VERIFICATION_HOST_URL = "https://manualverification-storyit-dev.web.app/"
            this.BRAND_DASHBOARD_URL = "https://foodfluence-dev-dashboard.web.app";
        } else {
            this.GOOGLE_API_KEY = process.env.REACT_APP_GOOGLE_API_KEY_PROD ?? "";
            this.MANUAL_VERIFICATION_HOST_URL = "https://manualverification-storyit.web.app/";
            this.BRAND_DASHBOARD_URL = "https://dashboard.foodfluence.io";
        }

        this.BRAND_FETCH_CLIENT_ID = '1idzh3Q29yRRsoLUFJK';

        if (process.env.NODE_ENV === 'production' && !process.env.USE_TEST_MODE) {
            console.log = function () { }; // disable console.log in production
        }
    }
}

export default Environment;
